<template>
  <div class="video-detail" v-if="data">
    <div class="detail-content">
      <div class="top">
        <div class="title">{{ data.title }}</div>
        <div class="video-info">
          <span class="upload-name">{{ data.opt_name || '' }} </span>
          <span class="upload-time">{{ data.addtime }}</span>
          <span>被引用：</span><span class="use-num">{{ data.num }}</span>
        </div>
      </div>
      <div class="tag-container">
        <div class="tag-list">
          <div class="tag-item" v-if="data.keyword1">{{ data.keyword1 }}</div>
          <div class="tag-item" v-if="data.keyword2">{{ data.keyword2 }}</div>
          <div class="tag-item" v-if="data.keyword3">{{ data.keyword3 }}</div>
        </div>
      </div>
      <div class="video-content">
        <video class="video" :src="data.info" controls></video>
      </div>
      <div class="desc-content">
        <div class="desc-title">
          <div class="line"></div>
          <div class="desc-text">单元描述</div>
          <div class="line"></div>
        </div>
        <div class="desc-html" v-html="data.disc"></div>
      </div>
    </div>
    <!--  -->
    <div class="bottom">
      <div class="btn-item red-btn" @click.stop="setTypeInc">
        <span>引用</span>
      </div>
      <div class="btn-item" @click.stop="collect">
        <span
          class="iconfont icon-shoucang1"
          :class="{ active: data.is_save === 0 }"
        ></span>
        <span>收藏</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      id: '',
      data: null,
      videoUrl:
        'https://cdnvue.gymcity.com.cn/%E5%81%A5%E8%90%8C%20%E5%8D%97%E4%BA%AC-%E8%8B%8F%E5%AE%81%E6%85%A7%E8%B0%B7%E9%A6%8615s.mp4',
      title: '直播单元',
      playing: false
    }
  },
  created() {
    this.getParams(this.$route.query)
    this.getDetail()
  },
  methods: {
    getParams(options) {
      this.id = (options && options.id) || ''
    },
    getDetail() {
      let params = {
        tid: this.id
      }
      this.$http
        .postApp('member/StorageLogin/getDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data = res.data
            this.replaceBr()
            this.setShare()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    setTypeInc() {
      let params = {
        tid: this.data.id
      }
      this.$http
        .postApp('member/StorageLogin/setTypeInc', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.num = parseInt(this.data.num) + 1
            this.$toast('引用成功')
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    collect() {
      let active = this.data.is_save === 0 ? true : false
      let params = {
        tid: this.data.id,
        type_0: this.data.type_id,
        type: active ? 2 : 1
      }
      this.$http
        .postApp('member/StorageLogin/optSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.is_save = active ? 1 : 0
            let tips = ''
            if (this.data.is_save === 0) {
              tips = '收藏成功'
            } else {
              tips = '取消收藏'
            }
            this.$toast(tips)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    replaceBr() {
      let str = this.data.disc
      str = str.replace(/\r\n/g, '<br/>')
      str = str.replace(/\n/g, '</br/>')
      str = str.replace(/\r/g, '</br/>')
      this.data.disc = str
    },
    setShare() {
      let desc =
        this.data.keyword1 +
        ' ' +
        this.data.keyword2 +
        ' ' +
        this.data.keyword3 +
        ' '
      let obj = {
        imgUrl: this.pics || '',
        title: this.title || '',
        desc: desc
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.video-detail {
  text-align: left;
  width: 100%;
  min-height: 100vh;
}
.video-detail .detail-content {
  background-color: #fff;
  padding: 5.3vw 6.4vw;
  box-sizing: border-box;
  margin-top: 2.7vw;
}
.video-detail .detail-content .top {
  border-bottom: 0.3vw dashed #ccc;
}
.video-detail .detail-content .title {
  font-family: PingFangSC-Medium;
  font-size: 4.8vw;
  font-weight: 600;
  letter-spacing: -0.2vw;
  color: #000;
  margin-bottom: 2.1vw;
}
.video-detail .detail-content .video-info {
  font-family: PingFangSC-Regular;
  font-size: 3.5vw;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 4.3vw;
  display: flex;
  align-items: center;
}
.video-detail .detail-content .video-info .upload-name {
  margin-right: 2vw;
}
.video-detail .detail-content .video-info .upload-time {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}
.video-detail .detail-content .video-info .use-num {
  font-family: PingFangSC-Medium;
  font-size: 4vw;
  color: #ff5a5a;
}
.video-detail .detail-content .tag-container {
  display: flex;
  align-items: center;
  margin-top: 4vw;
  margin-bottom: 5vw;
}
.video-detail .detail-content .tag-container .tag-list {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.video-detail .detail-content .tag-container .tag-list .tag-item {
  background-color: #f1f1f1;
  border-radius: 1.1vw;
  margin: 1.6vw 1.6vw 1.6vw 0vw;
  padding: 1.4vw 2.9vw;
  font-family: PingFangSC-Regular;
  font-size: 3.2vw;
  color: #000;
}
.video-detail .detail-content .video-content {
  width: 100%;
  margin-bottom: 8vw;
}
.video-content .video {
  height: 225px;
}
.video-detail .detail-content .video-content video {
  width: 100%;
}
.video-detail .detail-content .desc-content .desc-title {
  display: flex;
  align-items: center;
  margin-bottom: 3.5vw;
}
.video-detail .detail-content .desc-content .desc-title .desc-text {
  font-family: PingFangSC-Medium;
  font-size: 3.5vw;
  letter-spacing: -0.2vw;
  color: rgba(0, 0, 0, 0.5);
  margin: 0vw 4.5vw;
}
.video-detail .detail-content .desc-content .desc-title .line {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  height: 0.3vw;
  background-color: #e7e7e7;
}
.video-detail .detail-content .desc-content .desc-html {
  width: 100%;
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 3.7vw;
  line-height: 6.4vw;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 12.5vw;
}
.video-detail .bottom {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  z-index: 22;
  background: #fff;
  border-top: solid 0.3vw #f1f1f1;
}
.video-detail .bottom .btn-item {
  width: 50%;
  height: 12.8vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.8vw;
  color: #000;
  font-weight: 600;
}
.video-detail .bottom .btn-item .iconfont {
  margin-right: 3.2vw;
  color: #ccc;
  font-size: 4.5vw;
}
.video-detail .bottom .btn-item .active {
  color: #ff5a5a;
}
.video-detail .bottom .red-btn {
  background-color: #ff5a5a;
  color: #fff;
}
</style>
